import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, debounceTime, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedTrainedListService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getTrainedList(departmentType, registerType, page, perPage = 10, search): Observable<any> {
        let body = this.setBody();

        body.set('departmentType', departmentType);
        body.set('registerType', registerType);
        body.set('per_page', perPage);
        body.set('page', page);
        if (search) {
            body.set('search', search);
        }

        let response = this.http
            .post(this.urlService + this.routeAdress.route_coach_list, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
